'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = ['M63.9 448.1l79.4-30.9-48.5-48.5-30.9 79.4zm49.9-128.2l78.4 78.4 41.9-16.3-104-104-16.3 41.9z', 'M32 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.1 136c12.8-12.8 21.2-21.2 25.2-25.2 16.7-16.7 27.2-38.6 29.8-62.1l3-27.4 47.7 5.3-3 27.4c-3.8 34.3-19.2 66.3-43.6 90.7L184 169.9 150.1 136zM359 311l8.2-8.3c24.4-24.4 56.4-39.8 90.7-43.6l27.4-3 5.3 47.7-27.4 3c-23.5 2.6-45.4 13.1-62.1 29.8-4 4-12.5 12.5-25.2 25.2l-33.9-33.9 17-17zM503.5 42.3l-10 8.5c-14.8 12.5-33.7 19.1-53 18.6-16.6-.4-30.6 12.4-31.6 29l-1.6 27c-2.6 44.1-39.8 78.2-84 77-5.7-.2-11.2 1.8-15.5 5.4-7.2 6.1-17.4 14.7-30.6 25.9l-31-36.6c13.2-11.2 23.4-19.8 30.6-25.9 13.3-11.3 30.3-17.3 47.8-16.8 18.3 .5 33.7-13.6 34.7-31.9l1.6-27c2.5-42.5 38.3-75.3 80.8-74.2 7.6 .2 15-2.4 20.7-7.3l10-8.5 31 36.6zM63.9 448.1l79.4-30.9-48.5-48.5-30.9 79.4zM234 381.9l-104-104-16.3 41.9 78.4 78.4 41.9-16.3zM93 240.9L112 192c8.6 8.6 65.6 65.6 170.9 170.9L320 400c-.9 .3-96.9 37.7-288 112L0 480 93 240.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;